export const numberToGeneratorId = (n: number) => {
  return `G-${lz(n, 3)}`;
};

export const getFileName = (n: number, i: number) => {
  return `G-${lz(n, 3)}-${lz(i)}`;
};

const lz = (n: number, l = 2) => {
  return n.toString().padStart(l, '0');
};
